module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('div', {
    staticClass: "project-update row gutter-md"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row gutter-md justify-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-5"
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "project",
      "name": "name",
      "placeholder": "Tech con 2016"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "location",
      "placeholder": "Berlin"
    },
    model: {
      value: (_vm.item.location),
      callback: function($$v) {
        _vm.$set(_vm.item, "location", $$v)
      },
      expression: "item.location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row gutter-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.start_date_error
    }
  }, [_c('label', {
    attrs: {
      "for": "start_date"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.project.start_date')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "disabled-dates": {
        from: new Date(_vm.formattedEndDate)
      },
      "input-class": "input--datepicker",
      "id": "start_date",
      "name": "start_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.formattedStartDate),
      callback: function($$v) {
        _vm.formattedStartDate = $$v
      },
      expression: "formattedStartDate"
    }
  }), _vm._v(" "), (_vm.start_date_error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.' + _vm.start_date_error)))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.end_date_error
    }
  }, [_c('label', {
    attrs: {
      "for": "end_date"
    }
  }, [_vm._v(_vm._s(_vm.$t('models.project.end_date')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "clear-button": true,
      "disabled-dates": {
        to: new Date(_vm.formattedStartDate)
      },
      "input-class": "input--datepicker",
      "id": "end_date",
      "name": "end_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.formattedEndDate),
      callback: function($$v) {
        _vm.formattedEndDate = $$v
      },
      expression: "formattedEndDate"
    }
  }), _vm._v(" "), (_vm.end_date_error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.' + _vm.end_date_error)))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "classification-container"
  }, [_c('field', {
    staticClass: "is-buttonned",
    class: _vm.selectClass,
    attrs: {
      "type": "radio",
      "collection": _vm.classificationCollection,
      "label": _vm.$t('models.project.default_classification'),
      "params": {
        'no_i18n': true
      },
      "model": "project",
      "name": "default_classification"
    },
    on: {
      "input": _vm.inputClassification
    },
    model: {
      value: (_vm.item.default_classification),
      callback: function($$v) {
        _vm.$set(_vm.item, "default_classification", $$v)
      },
      expression: "item.default_classification"
    }
  })], 1), _vm._v(" "), _c('form-switch', {
    attrs: {
      "id": "scope_leads",
      "label": "models.project.scope_leads",
      "value": _vm.item.scope_leads_to_user
    },
    model: {
      value: (_vm.item.scope_leads_to_user),
      callback: function($$v) {
        _vm.$set(_vm.item, "scope_leads_to_user", $$v)
      },
      expression: "item.scope_leads_to_user"
    }
  }), _vm._v(" "), (!_vm.currentPlanIsTalents) ? _c('div', [(_vm.showCrmSyncSwitch()) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "reverse": true,
      "model": "project",
      "name": "sync_disabled",
      "value": _vm.item.sync_disabled
    },
    model: {
      value: (_vm.item.sync_disabled),
      callback: function($$v) {
        _vm.$set(_vm.item, "sync_disabled", $$v)
      },
      expression: "item.sync_disabled"
    }
  }) : _vm._e(), _vm._v(" "), _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "background_xml_export_enabled",
      "value": _vm.item.background_xml_export_enabled
    },
    model: {
      value: (_vm.item.background_xml_export_enabled),
      callback: function($$v) {
        _vm.$set(_vm.item, "background_xml_export_enabled", $$v)
      },
      expression: "item.background_xml_export_enabled"
    }
  }), _vm._v(" "), (_vm.allowedLeadReview()) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "enable_lead_review",
      "value": _vm.item.enable_lead_review
    },
    model: {
      value: (_vm.item.enable_lead_review),
      callback: function($$v) {
        _vm.$set(_vm.item, "enable_lead_review", $$v)
      },
      expression: "item.enable_lead_review"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.currentPlanIsTalents) ? _c('q-collapsible', {
    staticClass: "additional_data",
    attrs: {
      "label": _vm.$t('models.project.set_aditional_data_content')
    }
  }, [_c('div', [_c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('organizations.list'),
      expression: "'organizations.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "organization_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.organizations
    },
    model: {
      value: (_vm.item.organization_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "organization_id", $$v)
      },
      expression: "item.organization_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_campaign_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_campaign_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_campaign_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_campaign_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_sales_employee_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_sales_employee_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_sales_employee_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_sales_employee_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_marketing_employee_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_marketing_employee_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_marketing_employee_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_marketing_employee_foreign_id"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "crm_group_code_id"
    },
    model: {
      value: (_vm.item.additional_data.crm_group_code_foreign_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "crm_group_code_foreign_id", $$v)
      },
      expression: "item.additional_data.crm_group_code_foreign_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'is-unvalid': _vm.baseScoreError()
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "model": "project",
      "name": "base_score"
    },
    model: {
      value: (_vm.item.additional_data.base_score),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "base_score", _vm._n($$v))
      },
      expression: "item.additional_data.base_score"
    }
  }), _vm._v(" "), (_vm.baseScoreError()) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t('errors.base_score_error')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "mailchimp_list_id"
    },
    model: {
      value: (_vm.item.additional_data.mailchimp_list_id),
      callback: function($$v) {
        _vm.$set(_vm.item.additional_data, "mailchimp_list_id", $$v)
      },
      expression: "item.additional_data.mailchimp_list_id"
    }
  })], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "form-subtitle "
  }, [_vm._v(_vm._s(_vm.$t('ui.project_wizard.lead-sheets')))])]), _vm._v(" "), _c('form', {
    staticClass: "project-update--form right col-xs-12 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row gutter-sm"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    ref: "basic",
    staticClass: "leadsheet-box",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('basic')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/leadsheet-standard.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Standard")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('div', {
    ref: "advanced",
    staticClass: "leadsheet-box",
    on: {
      "click": function($event) {
        return _vm.setLeadSheet('advanced')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/leadsheet-advanced.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("Advanced")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    ref: "none",
    staticClass: "lead-sheet-selector"
  }, [(this.leadMasks.length > 0) ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('lead_masks.list'),
      expression: "'lead_masks.list'"
    }],
    attrs: {
      "errors": _vm.errors,
      "model": "project",
      "name": "lead_mask_id",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.leadMasks
    },
    on: {
      "input": function($event) {
        return _vm.setLeadSheet('none')
      }
    },
    model: {
      value: (_vm.item.lead_mask_id),
      callback: function($$v) {
        _vm.$set(_vm.item, "lead_mask_id", $$v)
      },
      expression: "item.lead_mask_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'lead_masks'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.project.create_leadsheet')))])], 1)])]), _vm._v(" "), (_vm.isCurrentlySelectedBasicOrAdvanced) ? _c('div', {
    staticClass: "info-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/info-message.svg")
    }
  }), _vm._v(" "), (_vm.currentlySelected == 'basic') ? _c('div', {
    staticClass: "info info-standard"
  }, [_c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_subtitle_1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.standard_description_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.standard_subtitle_2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.standard_description_2')))])]) : _vm._e(), _vm._v(" "), (_vm.currentlySelected == 'advanced') ? _c('div', {
    staticClass: "info info-advanced"
  }, [_c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_subtitle_1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.advanced_description_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "bold-text"
  }, [_vm._v(_vm._s(_vm.$t('ui.project.advanced_subtitle_2')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.project.advanced_description_2')))])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-12"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary btn-flat",
    attrs: {
      "data-action": "project.cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), (_vm.type) ? _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    attrs: {
      "type": "submit",
      "data-action": "project.update"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.pages.project-' + _vm.type + '-button')))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5724acc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectUpdate.vue
// module id = 1910
// module chunks = 0